import { useFormContext } from 'react-hook-form';
import type { OrderFormBase } from './schema';

export const NotesSection = () => {
  const { register } = useFormContext<OrderFormBase>();

  return (
    <label className="flex flex-col gap-1">
      <span className="font-bold">備考</span>
      <textarea {...register('notes')} rows={3} placeholder="備考を入力" />
    </label>
  );
};
